import { Component, OnInit, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { ActionsService } from '../services/actions.service';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatAutocomplete, MatSnackBar, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DocumentService } from '../services/document.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ClientService } from '../services/client.service';
import { RequestService } from '../services/request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

export interface Item {
  name: string;
  item_number: number;
  id: number;
}


export interface docItems {
  document_number: number;
  serial_number: number;
  item: any;
  quantity: any;
  unit: any;
  price: any;
  total_price: any;
  // code:any;
  // price:any;
  // product:any;
  qty: any;
  // sum:any;
  units: any;
}


export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-document-insert',
  templateUrl: './document-insert.component.html',
  styleUrls: ['./document-insert.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  encapsulation: ViewEncapsulation.None
})



export class DocumentInsertComponent implements OnInit {
  //table
  displayedColumns: any;
  columnsToDisplay: any;
  dataSource: any;
  selection: any;
  items: any;//indicators
  articles: any;// table rows
  services: any;
  documents: any;
  //clients autocomplete
  clientControl = new FormControl();
  clients: any;
  client_name: any;
  selectedClient: any;
  filteredOptions: Observable<any>;

  //subjects autocomplete
  subjectControl = new FormControl();
  subjects: any;
  selectedSubject: any;
  subjectAccounts: any;
  subject_name: any;
  bank_account: any;
  selected_account: any;
  filteredSubjectOptions: Observable<any>;

  //item name
  itemControl = new FormControl();
  options: Item[] = [];
  filteredItemOptions: Observable<Item[]>;
  item: any;
  //item number
  itemNumberControl = new FormControl();
  filteredItemNumberOptions: Observable<Item[]>;
  item_number: any;

  //data
  document_type: any;
  document_number: number = 0;
  fromDate: any;
  danuchno_subitie: any;
  dogovor_poruchka: any;
  unit: string;
  quantity: number = 1;
  price: any = 0;
  total_price: any = 0;
  dds_type: string;
  dds_reason: string = '';
  payment_type: string = "cash";
  document_price: number = 0;
  document_dds: number = 0;
  document_total: number = 0;
  createdBy: string;


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;

  constructor(private documentService: DocumentService,
    public dialog: MatDialog,
    private clientService: ClientService,
    public snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private requestService: RequestService,
    private dateAdapter: DateAdapter<Date>) {
    this.getClients();
    this.getSubjects();

    dateAdapter.setLocale('en-in');
  }


  ngOnInit() {
    this.getItems();
    
    if (this.router.url == '/documentEdit/' + this.route.snapshot.paramMap.get('id')) {
      this.editDocument(this.route.snapshot.paramMap.get('id'));
      this.getDocumentItems(this.route.snapshot.paramMap.get('id'));
    } else {
      this.items = [];
      this.articles = [];
      this.services = [];
      this.document_type = +this.route.snapshot.paramMap.get('id');
      this.dds_type = 'standart';
      this.getDocumentNumber();
      this.getDocumentItems(0);
    }
  }

  editDocument(id) {
    this.documentService.editDocument(id).subscribe(resp => {
      if (resp != null) {
        console.log(resp);
        this.document_number = resp.data.docNumber,
          this.document_type = resp.type,
          this.fromDate = new Date(resp.data.fromDate),
          this.payment_type = resp.data.payment.type,
          this.dds_type = resp.data.dds_type,
          this.dds_reason = resp.data.dds_reason,
          this.items = resp.data.articles,
          this.services = resp.data.additionalServices,
          this.danuchno_subitie = new Date(resp.data.danuchno_subitie),
          this.dogovor_poruchka = resp.data.dogovor_poruchka,
          this.subject_name = resp.data.supplier.name + ' - ' + resp.data.supplier.eik;
        this.client_name = resp.data.client.name + ' - ' + resp.data.client.eik;

        this.subjectSelected(resp.data.supplier.name + ' - ' + resp.data.supplier.eik);
        this.clientSelected(resp.data.client.name + ' - ' + resp.data.client.eik);
        this.selected_account = resp.data.payment.iban_id,
          this.createdBy = resp.data.sustavil
        if (this.payment_type == 'bank') {
          this.accountInfo();
        }
        if (resp.data.supplier.vat.length < 1) {
          this.dds_type = "zero";
        }
      }
      this.documentPrice();
    })
  }

  getClients() {
    this.requestService.getClients().subscribe(data => {
      this.clients = data;
      this.filteredOptions = this.clientControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    });

    return this.clients;
  }

  getDocumentNumber() {
    this.documentService.getDocumentNumber(this.document_type).subscribe(data => {
      this.document_number = data;
    });
  }

  clientSelected(name) {
    if (name != null) {
      this.requestService.clientInfo(name).subscribe(data => {
        this.selectedClient = data;

      });
    } else {
      this.selectedClient = [];
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.clients.filter(option => option.toLowerCase().includes(filterValue));
  }

  getSubjects() {
    this.documentService.getSubjects().subscribe(data => {
      this.subjects = data;
      this.filteredSubjectOptions = this.subjectControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filterSubject(value))
        );
    });


  }

  subjectSelected(name) {
    if (name != null) {
      this.documentService.subjectInfo(name).subscribe(data => {
        this.selectedSubject = data['subject'];
        this.subjectAccounts = data['subject_accounts'];
        // this.payment_type = 'bank';
        this.bank_account = data['default_account'];
        this.selected_account = data['default_account']['id'];
      });
    } else {
      this.selectedSubject = [];
    }
  }

  accountInfo() {
    this.documentService.accountInfo(this.selected_account).subscribe(data => {
      this.bank_account = data;
    });
  }

  private _filterSubject(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.subjects.filter(option => option.toLowerCase().includes(filterValue));
  }

  getItems() {
    this.documentService.getItems().subscribe(data => {
      this.options = data;
      this.filteredItemOptions = this.itemControl.valueChanges
        .pipe(
          startWith<string | Item>(''),
          // map(value => typeof value === 'string' ? value : value.name),
          // map(name => name ? this._filterItems(name) : this.options.slice()),
          map(value => typeof value === 'string' ? this._filterItemsName(value) : this._filterItemsName(value.name.toString()))
        );
      this.filteredItemNumberOptions = this.itemNumberControl.valueChanges
        .pipe(
          startWith<string | Item>(''),
          map(value => typeof value === 'string' ? this._filterItemsNumber(value) : this._filterItemsNumber(value.item_number.toString())),
          // map(name => name ? this._filterItemsNumber(value.item_number) : this.options.slice())
        );

    });
  }

  setData() {
    // console.log(this.item_number);
    if (this.item_number) {
      this.unit = this.item_number.unit;
      this.price = this.item_number.no_dds_price;
      this.quantity = 1;
      this.total_price = this.item_number.no_dds_price;
    } else {
      this.price = 0;
      this.quantity = 1;
      this.total_price = 0;
    }
  }

  totalPrice() {
    this.total_price = this.quantity * this.price;
  }

  getDocumentItems(id) {
    this.documentService.getDocumentItems(id).subscribe(data => {
      if (data != null) {
        this.articles = data

        this.articles.forEach(element => {
          var itemIndex = this.options.indexOf(element);
          if (itemIndex != -1) {
            this.options.splice(itemIndex, 1);
          }
        });


        this.displayedColumns = ['document_number', 'serial_number', 'item', 'unit', 'quantity', 'price', 'total_price', 'actions'];
        this.columnsToDisplay = this.displayedColumns.slice();
        this.updateTableData();
        this.documentPrice();
      }
    });

  }


  displayFn(user?: Item): string | undefined {
    if (user) {
      this.item = user.item_number;
    }
    return user ? user.name : undefined;
  }

  // private _filterItems(name: string): Item[] {
  //   const filterValue = name.toLowerCase();
  //   return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  // }

  displayFnNumber(user?: Item): number | undefined {
    if (user) {
      this.item = user.name;
    }

    return user ? user.item_number : undefined;
  }

  private _filterItemsNumber(name: string): Item[] {
    const filterValue = name.toLowerCase();
    //option.item_number.toString().toLowerCase().indexOf(filterValue) === 0
    return this.options.filter(option => option.item_number.toString().toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterItemsName(name: string): Item[] {
    const filterValue = name.toLowerCase();
    //option.item_number.toString().toLowerCase().indexOf(filterValue) === 0
    return this.options.filter(option => option.name.toString().toLowerCase().indexOf(filterValue) === 0);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }


  addRow() {
    console.log(this.item_number.isSerivce, this.items.length);
    if (this.item_number) {
      var data = {
        code: this.item_number.item_number,
        id: this.item_number.id,
        isService: this.item_number.isService,
        product: this.item_number.name,
        units: this.item_number.unit,
        qty: this.quantity,
        no_dds_price: this.price,
        price: this.item_number.price,
        no_dds_sum: this.total_price,
        sum: this.item_number.price * this.quantity,
        number: this.item_number.isService ? this.services.length : this.items.length
      }
      if (data.isService) {
        this.services.push(data);
      } else {
        this.items.push(data);
      }
      console.log(this.items);
      // var itemIndex = this.options.indexOf(this.item_number);
      // if(itemIndex != -1){
      //   this.options.splice(itemIndex,1);
      // }
      // console.log(this.item_number,this.options,this.options.indexOf(this.item_number));
      this.articles.push(data);
      this.updateTableData();
      this.documentPrice();
      this.item_number = '';
      this.unit = null;
      this.quantity = 1;
      this.price = null;
      this.total_price = null;
    } else {
      this.openSnackBar('Изберете артикул', null);
    }

  }

  removeRow(item) {
    var index = this.articles.indexOf(item);
    console.log(item);
    if (item.isService) {
      delete this.services[item.number];
      this.services = this.services.filter(function (item) {
        return item !== undefined;
      });
    } else {
      delete this.items[item.number];
      this.items = this.items.filter(function (item) {
        return item !== undefined;
      });
    }
    if (index != -1) {
      this.articles.splice(index, 1);
      this.updateTableData();
      this.documentPrice();
    }

  }

  updateTableData() {
    this.dataSource = new MatTableDataSource<docItems>(this.articles);
    this.selection = new SelectionModel<docItems>(true, []);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  documentPrice() {
    this.document_total = 0;
    this.document_dds = 0;
    this.document_price = 0;
    var expressReq = false;
    if (this.articles != undefined) {
      this.articles.forEach(element => {
        this.document_total += parseFloat(element.sum);
        if (element.isService && element.id == 2) {
          expressReq = true;
        }
      });
    }
    if (expressReq) {
      this.document_total = this.document_total + (this.document_total / 2);
    }
    if (this.dds_type == "standart" || this.dds_type == undefined) {
      this.document_dds = (this.document_total / 1.2) * 0.2;
      this.document_price = this.document_total - this.document_dds;
    } else {
      this.document_dds = 0;
      this.document_price = this.document_total;
    }

  }

  submit(data) {
    if (this.items.length < 1) {
      this.openSnackBar('Добавете поне един артикул в таблицата', null);
    } else if (!this.selectedClient) {
      this.openSnackBar('Изберете валиден клиент', null);
    } else if (!this.selectedSubject) {
      this.openSnackBar('Изберете валиден доставчик', null);
    } else {

      if (this.danuchno_subitie) {

        this.danuchno_subitie = new Date(this.danuchno_subitie).toLocaleDateString('en-GB');
      }
      if (this.fromDate) {
        this.fromDate = new Date(this.fromDate).toLocaleDateString('en-GB');
      }
      var docData = {
        document_type: this.document_type,
        docNumber: this.document_number,
        fromDate: this.fromDate,
        orderDate: this.fromDate,
        danuchno_subitie: this.danuchno_subitie,
        dogovor_poruchka: this.dogovor_poruchka,
        client: this.selectedClient,
        supplier: this.selectedSubject,
        items: this.items,
        services: this.services,
        price: this.document_price,
        dds: this.document_dds,
        total_price: this.document_total,
        payment: {
          type: this.payment_type
        },
        bank: this.bank_account,
        sustavil: this.createdBy,
        dds_type: this.dds_type,
        dds_reason: this.dds_reason
      }

      console.log(docData);
      var routeId = this.route.snapshot.paramMap.get('id');
      if (this.router.url == '/documentEdit/' + routeId) {
        this.documentService.updateDoc(docData, routeId).subscribe(resp => {
          this.fromDate = new Date(resp.fromDate);
          this.danuchno_subitie = new Date(resp.danuchno_subitie);
          this.router.navigate(['/documents']);
        });
      } else {
        this.documentService.saveDoc(docData).subscribe(resp => {
          this.fromDate = new Date(resp.fromDate);
          this.danuchno_subitie = new Date(resp.danuchno_subitie);
          this.router.navigate(['/documents']);
        });
      }
    }


  }



  editRow(item): void {


    var articleIndex = this.articles.indexOf(item);
    console.log(this.items, item);
    var item_number = {
      item_number: item.code,
      name: item.product,
      no_dds_price: item.no_dds_price,
      no_dds_sum: item.no_dds_sum,
      isService: this.items[item.number].isService,
      code: this.items[item.number].code,
      qty: item.qty,
      units: item.units ? item.units : '',
      number: item.number,
    }
    console.log(item_number);
    const dialogRef = this.dialog.open(EditRow, {
      width: '800px',
      data: { item: item_number }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && JSON.stringify(item) !== JSON.stringify(result)) {
        this.articles[articleIndex] = result;
        console.log(this.services.length, this.items.length);
        if (result.isSerivce) {
          result['number'] = this.services.length - 1;
        } else {
          result['number'] = this.items.length - 1;
        }

        if (item.isService) {
          if (result.isService) {

            this.services[item.number] = result;
          } else {
            delete this.services[item.number];
            this.services = this.services.filter(function (item) {
              return item !== undefined;
            });

            this.items.push(result);
          }
        } else {
          if (result.isService) {
            delete this.items[item.number];
            this.items = this.items.filter(function (item) {
              return item !== undefined;
            });
            this.services.push(result);
          } else {
            this.items[item.number] = result;
          }
        }

        if ((this.router.url == '/documentEdit/' + this.route.snapshot.paramMap.get('id'))) {
          if (this.danuchno_subitie) {
            this.danuchno_subitie = this.danuchno_subitie.toLocaleDateString('en-GB');
          }
          if (this.fromDate) {
            this.fromDate = this.fromDate.toLocaleDateString('en-GB');
          }
          var docData = {
            document_type: this.document_type,
            docNumber: this.document_number,
            fromDate: this.fromDate,
            orderDate: this.fromDate,
            danuchno_subitie: this.danuchno_subitie,
            dogovor_poruchka: this.dogovor_poruchka,
            client: this.selectedClient,
            supplier: this.selectedSubject,
            items: this.items,
            services: this.services,
            price: this.document_price,
            dds: this.document_dds,
            total_price: this.document_total,
            payment: {
              type: this.payment_type
            },
            bank: this.bank_account,
            sustavil: this.createdBy,
            user_id: localStorage.getItem('user_id'),
            dds_type: this.dds_type,
            dds_reason: this.dds_reason
          }
          var docId = this.route.snapshot.paramMap.get('id');
          this.documentService.updateDoc(docData, docId).subscribe(resp => {
            this.fromDate = new Date(resp.fromDate);
            this.danuchno_subitie = new Date(resp.danuchno_subitie);
            this.getDocumentItems(docId);
          });
        }else{
          this.updateTableData();
          this.documentPrice();
        }
      }
    });
  }




}


@Component({
  selector: 'editRow',
  templateUrl: 'editRow.html',
})
export class EditRow {

  itemNumberControl = new FormControl();
  filteredItemNumberOptions: Observable<Item[]>;
  item_number: any;
  itemControl = new FormControl();
  options: Item[] = [];
  item: any;
  filteredItemOptions: Observable<Item[]>;


  constructor(
    public dialogRef: MatDialogRef<EditRow>, private documentService: DocumentService,
    @Inject(MAT_DIALOG_DATA) public data: docItems) {
    this.getItems();
    this.item_number = data.item;
    console.log(data.item);
    this.displayFn(this.item_number);
    this.displayFnNumber(this.item_number);
  }


  setData() {
    if (this.item_number) {
      this.data.item.units = this.item_number.unit;
      this.data.item.no_dds_price = this.item_number.no_dds_price;
      if (this.item_number.item_number != this.data.item.item_number) {
        this.data.item.qty = 1;
      } else {
        this.data.item.qty = this.data.item.qty;
      }

      this.data.item.no_dds_sum = this.item_number.no_dds_price * this.data.item.qty;
    } else {
      this.data.item.price = 0;
      this.data.item.qty = 1;
      this.data.item.total_price = 0;
    }
  }

  totalPrice() {
    this.data.item.no_dds_sum = this.data.item.qty * this.data.item.no_dds_price;
  }

  save(rowData) {
    // if (this.item_number) {
    console.log(this.item_number);
    var data = {
      code: this.item_number.item_number,
      id: this.item_number.id,
      isService: this.item_number.isService,
      product: this.item_number.name,
      units: rowData.unit,
      qty: rowData.quantity,
      no_dds_price: rowData.price,
      price: this.item_number.price,
      no_dds_sum: rowData.total_price,
      sum: (rowData.total_price * 1.2),
    }
    this.dialogRef.close(data);
    //   console.log(data);
    //   if(data.isService){
    //     this.services.push(data);
    //   }else{
    //     this.items.push(data);
    //   }
    //   console.log(this.items);
    //   this.articles.push(data);
    //   this.updateTableData();
    //   this.documentPrice();
    //   this.item_number = '';
    //   this.unit = null;
    //   this.quantity = 1;
    //   this.price = null;
    //   this.total_price = null;
    // } else {
    //   this.openSnackBar('Изберете артикул', null);
    // }
  }

  getItems() {
    this.documentService.getItems().subscribe(data => {
      this.options = data;
      this.filteredItemOptions = this.itemControl.valueChanges
        .pipe(
          startWith<string | Item>(''),
          // map(value => typeof value === 'string' ? value : value.name),
          // map(name => name ? this._filterItems(name) : this.options.slice()),
          map(value => typeof value === 'string' ? this._filterItemsName(value) : this._filterItemsName(value.name.toString()))
        );
      this.filteredItemNumberOptions = this.itemNumberControl.valueChanges
        .pipe(
          startWith<string | Item>(''),
          map(value => typeof value === 'string' ? this._filterItemsNumber(value) : this._filterItemsNumber(value.item_number.toString())),
          // map(name => name ? this._filterItemsNumber(value.item_number) : this.options.slice())
        );

    });
  }


  displayFn(user?: Item): string | undefined {
    if (user) {
      this.item = user.item_number;
    }
    return user ? user.name : undefined;
  }

  displayFnNumber(user?: Item): number | undefined {
    if (user) {
      this.item = user.name;
    }

    return user ? user.item_number : undefined;
  }

  private _filterItemsNumber(name: string): Item[] {
    const filterValue = name.toLowerCase();
    //option.item_number.toString().toLowerCase().indexOf(filterValue) === 0
    return this.options.filter(option => option.item_number.toString().toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterItemsName(name: string): Item[] {
    const filterValue = name.toLowerCase();
    //option.item_number.toString().toLowerCase().indexOf(filterValue) === 0
    return this.options.filter(option => option.name.toString().toLowerCase().indexOf(filterValue) === 0);
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}